import React from "react";
import Modal from "react-bootstrap/Modal";
import Spinner from "react-bootstrap/Spinner";

const Popup = ({ loading, modalText, loadError }) => {
  return (
    <Modal size="lg" centered show={loading} backdrop="static">
      <Modal.Body className="text-center">
        <div>{modalText}</div>
        {!loadError && <Spinner animation="border" variant="primary" />}
      </Modal.Body>
    </Modal>
  );
};
export default Popup;
